// extracted by mini-css-extract-plugin
export default {"form":"component_form__I+k0k","submitButton":"component_submitButton__SoWI2","wrapper":"component_wrapper__YqOqI"};